export default "__VITE_ASSET__f6a3d33e__"